import React, { useState, useEffect } from 'react';
import { createPortal } from 'react-dom';
import { toast } from 'react-toastify';
import api from '../utils/api';

export default function AssignTrainerModal({ session, onClose, onSaved }) {
  const [trainers, setTrainers] = useState([]);
  const [selected, setSelected] = useState('');
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    api.get('/api/users/trainers').then(r => setTrainers(r.data.data || [])).catch(() => {});
  }, []);

  async function handleSave() {
    if (!selected) { toast.warn('Please select a trainer.'); return; }
    const trainer = trainers.find(t => String(t.id) === String(selected));
    if (!trainer) {
      toast.error('The selected trainer is no longer available. Please choose another trainer.');
      return;
    }
    setSaving(true);
    try {
      let intakes = session.intakes;
      if (typeof intakes === 'string') {
        try { intakes = JSON.parse(intakes); } catch (_) { intakes = [intakes]; }
      }
      const res = await api.put(`/api/sessions/${session.id}`, {
        schedule_name: session.schedule_name,
        session_type: session.session_type || 'training',
        force_present: !!session.force_present,
        assessment_basis: session.assessment_basis || null,
        intakes: Array.isArray(intakes) ? intakes : [intakes],
        venue_id: session.venue_id,
        session_date: String(session.session_date).slice(0, 10),
        start_time: String(session.start_time).slice(0, 8),
        end_time: session.end_time ? String(session.end_time).slice(0, 8) : '',
        trainer_id: trainer.id,
        trainer_name: trainer.name,
        trainer_email: trainer.email,
        trainer_salutation: trainer.salutation || null,
        trainer_first_name: trainer.first_name || null,
      });
      onSaved({ ...res.data, message: res.data.calendarSynced === false ? res.data.message : 'Trainer assigned.' });
    } catch (err) {
      toast.error(err.response?.data?.message || 'Failed.');
    } finally {
      setSaving(false);
    }
  }

  return createPortal(
    <div className="modal d-block" style={{ background: 'rgba(0,0,0,0.5)' }}>
      <div className="modal-dialog modal-dialog-centered" style={{ maxWidth: 420 }}>
        <div className="modal-content">
          <div className="modal-header">
            <h6 className="modal-title"><i className="bi bi-person-badge me-2" />Assign Trainer</h6>
            <button className="btn-close btn-close-white" onClick={onClose} />
          </div>
          <div className="modal-body">
            <label className="form-label">Select Trainer</label>
            <select className="form-select" value={selected} onChange={e => setSelected(e.target.value)}>
              <option value="">Choose trainer…</option>
              {trainers.map(t => <option key={t.id} value={t.id}>{t.name} ({t.email})</option>)}
            </select>
          </div>
          <div className="modal-footer">
            <button className="btn btn-outline-secondary btn-sm" onClick={onClose}>Cancel</button>
            <button className="btn btn-tmis-primary btn-sm" onClick={handleSave} disabled={saving}>
              {saving && <span className="spinner-border spinner-border-sm me-1" />}
              Assign
            </button>
          </div>
        </div>
      </div>
    </div>,
    document.body
  );
}
